import { useTranslation } from "react-i18next"
import { createAccountStore } from "@/stores/account"

import useRouter from "@/hooks/router/useRoute"
import BasicCard from "@/app/settings/overview/BasicCard"

import "./Equipment.scss"

const cellImage = "/images/cell_bx_black.png"
const dockImage = "/images/dock.png"
const liveHubImage = "/images/live_hub.png"

export default function Equipment() {
  const { t } = useTranslation("")
  const router = useRouter()
  const teamProfileInfo = createAccountStore((state) => state.teamProfileInfo)

  const equipments = [
    {
      key: "cells",
      image: cellImage,
      count: teamProfileInfo?.cellCount || 0,
      width: 37,
      height: 63,
    },
    {
      key: "docks",
      image: dockImage,
      count: teamProfileInfo?.dockCount || 0,
      width: 82,
      height: 50,
    },
    {
      key: "liveHubs",
      image: liveHubImage,
      count: teamProfileInfo?.hubCount || 0,
      width: 63,
      height: 50,
    },
  ]

  return (
    <BasicCard title={t("equipments")} to="/settings/club/equipments">
      <div className="EquipmentCont" onClick={() => router?.push("/settings/club/equipments")}>
        {equipments.map((equipment) => {
          return (
            <div key={equipment.key} className="equipment-item">
              <div className="equipment-image-wrapper">
                <img
                  src={equipment.image}
                  alt={equipment.key}
                  width={equipment.width}
                  height={equipment.height}
                  className={`EquipmentImage ${equipment.key}`}
                />
              </div>
              <div className="equipment-text-wrapper">
                <p>{t(equipment.key)}</p>
                <p>{equipment.count}</p>
              </div>
            </div>
          )
        })}
      </div>
    </BasicCard>
  )
}
